import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import {HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import {environment} from '../../environments/environment';
import { userInfo } from 'os';
@Injectable({
  providedIn: 'root'
})
export class ChatService {

  name! :String ;
  private backEventSource = new Subject<void>();
  backEvent$ = this.backEventSource.asObservable();
  private readLastMessageSource = new Subject<void>();
  lastMessageEvent$ = this.readLastMessageSource.asObservable();
  loading = true

  private baseUrl2= environment['chatApiUrl'];

   public currentUserSubject: BehaviorSubject<any>;
   public currentUser: Observable<any>;

   constructor(private http: HttpClient, private router: Router) {
    const user = localStorage.getItem('currentUser');
    this.currentUserSubject = new BehaviorSubject<any>(user ? JSON.parse(user) : null);
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue() {
    return this.currentUserSubject.value;
  }


    logout(): void {
      localStorage.removeItem('currentUser');
      this.router.navigate(["/menu-login/login"]);
    }

    getToken(): string | null {
      return this.currentUserValue?.access_token;
    }

  getChatUsers(): Observable<any> {
    const token = this.getToken();
    return this.http.get<any>(`${this.baseUrl2}/chat-users`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  getMessages(Id:number, page:number, size:number): Observable<any> {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    const body = { id: Id, page:page, size:size };
    return this.http.post<any>(`${this.baseUrl2}/messages`, body, { headers });
  }
  getUnreadMessages(page:number, size:number): Observable<
    {
      messages: {
        id_destinatario: number;
        messaggio: string;
        letto: string,
          tipo ? : string;
        file_name ? : string;
        file_extension ? : string;
        file_content ? : string;
      }  [],
      'current_page' :number,
      'total_pages' :number,
      'total_messages' :number
    }
> {
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    const body = {  page, size };
    return this.http.post<any>(`${this.baseUrl2}/toread`, body, { headers });
  }

  getUser(Id: number): Observable<any>{
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    const body = { id: Id };
    return this.http.post<any>(`${this.baseUrl2}/user`, body, { headers });
  }

  sendMessage(Id: number, Message: string, tipo?: string, fileName?:string, fileExtension?:string, fileContent?:string): Observable<any>{
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    interface MessageBody {
      id_destinatario: number;
      messaggio: string;
      letto: string,
      tipo?: string;
      file_name?: string;
      file_extension?: string;
      file_content?: string;
    }

    const body:MessageBody ={
      id_destinatario: Id,
      messaggio: Message,
      letto: 'da leggere',
    };
    if (tipo !== 'testuale' && fileName && fileExtension && fileContent) {
      body.tipo = tipo;
      body.file_name = fileName;
      body.file_extension = fileExtension;
      body.file_content = fileContent;
    }
    return this.http.post<any>(`${this.baseUrl2}/write`,body, {headers});
  }



  getAllUsers(ricerca?:string): Observable<any>{
    let body = ricerca? {name : ricerca} : {};
    const token = this.getToken();
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });
    return this.http.post<any>(`${this.baseUrl2}/users`, body, {headers});
  }

  downloadFile(id_messaggio: number): Observable<HttpResponse<Blob>> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      'Accept': 'application/octet-stream'
    });

    return this.http.get(`${this.baseUrl2}/download/${id_messaggio}`, {
      headers,
      responseType: 'blob',
      observe: 'response'
    });
}


createFileType(extension: string): string {
    switch (extension) {
        case 'pdf':
        case 'csv':
            return `application/${extension}`;
        case 'jpeg':
        case 'png':
            return `image/${extension}`;
        case 'txt':
            return 'text/plain';
        case 'ppt':
        case 'pps':
        case 'ppa':
            return 'application/vnd.ms-powerpoint';
        case 'pptx':
            return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
        case 'doc':
        case 'dot':
            return 'application/msword';
        case 'docx':
            return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
        case 'xls':
        case 'xla':
            return 'application/vnd.ms-excel';
        case 'xlsx':
            return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        default:
            return 'application/octet-stream';
    }
}

  public setName(name:String){
    this.name = name;
  }

  public getName():String{
    return this.name;
  }

  public setLoading(value : boolean){
    this.loading = value
  }

  public getLoading():boolean{
    return this.loading;
  }

  public emitBackEvent() {
    this.backEventSource.next();
  }

  public emitReadLastMessageEvent(){
    console.log("STo nel servizio")
    this.readLastMessageSource.next()

  }




}
